import React, { useState, useEffect } from 'react'
import { pb } from '../api-utils'
import { useLoginModal } from '../contexts/LoginModalContext'

interface ProtectedRouteProps {
    children: React.ReactNode
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(pb.authStore.isValid)
    const { setIsLoginModalOpen } = useLoginModal()

    useEffect(() => {
        // Subscribe to auth changes
        const unsubscribe = pb.authStore.onChange(() => {
            setIsAuthenticated(pb.authStore.isValid)
        })
        return unsubscribe
    }, [])

    if (!isAuthenticated) {
        return (
            <div
                className="view force-full-view"
                style={{
                    background: 'linear-gradient(to right, #fdfa52, #FFAE42)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '60vh',
                    padding: '2rem'
                }}
            >
                <div style={{ textAlign: 'center', maxWidth: '500px' }}>
                    <div className="title forceBlack" style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>
                        <i className="fa fa-lock" aria-hidden="true" style={{ marginRight: '0.5rem' }}></i>
                        Login Required
                    </div>
                    <p className="forceBlack" style={{ fontSize: '1.25rem', marginBottom: '2rem' }}>
                        Please login to view your account information.
                    </p>
                    <button
                        className="button is-large"
                        style={{
                            background: '#232043',
                            color: '#fdfa52',
                            fontWeight: 600,
                            border: 'none',
                            padding: '1rem 2rem',
                            cursor: 'pointer'
                        }}
                        onClick={() => setIsLoginModalOpen(true, { redirectOnSuccess: false })}
                    >
                        <i className="fa fa-user" aria-hidden="true" style={{ marginRight: '0.5rem' }}></i>
                        Login
                    </button>
                </div>
            </div>
        )
    }

    return <>{children}</>
}

export default ProtectedRoute
